// import React, { useEffect, useRef, useState } from "react";
// import { NavLink, useLocation, useNavigate } from "react-router-dom";
// import { ROLL_CALL_API_BASE_URL } from "../../feature-module/Pereco/RollCall/RollCallConfig/RollCallConfig";
// // import { SidebarData1 } from "../../core/json/sidebar_dataone";

// const HorizontalSidebar = () => {
//   const navigate = useNavigate();

//   const [SidebarData, setSidebarData] = useState([]);
//   const [tokenData, setTokenData] = useState(null);
//   const [superIdData, setSuperIdData] = useState(null);

//   useEffect(() => {
//     const token = sessionStorage.getItem("authToken");
//     const superId = sessionStorage.getItem("superId");

//     if (token && superId) {
//       setTokenData(token);
//       setSuperIdData(superId);
//     } else {
//       console.warn("User data not found in sessionStorage");
//       navigate("/signin");
//     }
//     console.log(superIdData);
//   }, [navigate]);

//   useEffect(() => {
//     fetch(
//       `${ROLL_CALL_API_BASE_URL}portal/access/getmenu?RoleId=3&SuperId=${superIdData}`,
//       {
//         method: "GET",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${tokenData}`,
//         },
//       }
//     )
//       .then((response) => {
//         if (!response.ok) {
//           throw new Error("Failed to fetch menu");
//         }
//         return response.json();
//       })
//       .then((data) => {
//         console.log(
//           data.ResultData,
//           "data.ResultDatadata.ResultDatadata.ResultData"
//         );
//         setSidebarData(data.ResultData);
//       })
//       .catch((error) => {
//         console.error("Error fetching menu:", error);
//       });
//   }, [superIdData]);

//   const [opendSubMenu, setOpendSubMenu] = useState([null, null]);
//   const sidebarRef = useRef(null);
//   const location = useLocation();
//   // const currentPath = location.pathname.split("/")[1];

//   const showMenu = (title) => {
//     setOpendSubMenu((prevState) =>
//       prevState[0] === title ? [null, null] : [title, null]
//     );
//   };

//   const showSubMenu = (title) => {
//     setOpendSubMenu((prevState) =>
//       prevState[1] === title ? [prevState[0], null] : [prevState[0], title]
//     );
//   };

//   // const handleClickOutside = (event) => {
//   //   if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
//   //     setOpendSubMenu([null, null]);
//   //   }
//   // };

//   // useEffect(() => {
//   //   document.addEventListener("mousedown", handleClickOutside);
//   //   return () => {
//   //     document.removeEventListener("mousedown", handleClickOutside);
//   //   };
//   // }, []);

//   const handleClickOutside = (event) => {
//     if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
//       setOpendSubMenu([null, null]);
//     }
//   };

//   useEffect(() => {
//     document.addEventListener("click", handleClickOutside, true);
//     return () => {
//       document.removeEventListener("click", handleClickOutside, true);
//     };
//   }, []);

//   // const filteredMenu = Object.keys(SidebarData).find((key) =>
//   //   location.pathname.startsWith(`/${key}`)
//   // )
//   //   ? SidebarData[currentPath]
//   //   : [];

//   const isActiveMainMenu = (mainMenus) => {
//     const currentPath = location.pathname || "";

//     return (
//       (mainMenus.route &&
//         currentPath.split("/")[1] === mainMenus.route.split("/")[1]) ||
//       mainMenus.subRoutes?.some(
//         (subMenu) =>
//           subMenu.route &&
//           currentPath.split("/")[1] === subMenu.route.split("/")[1]
//       )
//     );
//   };

//   const isActiveSubMenu = (mainMenus) => {
//     const currentPath = location.pathname || "";

//     return (
//       (mainMenus.route &&
//         currentPath.split("/")[1] === mainMenus.route.split("/")[1]) ||
//       mainMenus.subRoutes?.some(
//         (subMenu) =>
//           subMenu.route &&
//           currentPath.split("/")[1] === subMenu.route.split("/")[1]
//       )
//     );
//   };

//   useEffect(() => {
//     setOpendSubMenu([null, null]);
//   }, [location.pathname]);
//   return (
//     <div
//       className="sidebar sidebar-horizontal"
//       id="horizontal-menu"
//       ref={sidebarRef}
//     >
//       <div className="sidebar-menu" id="sidebar-menu-3">
//         <div className="main-menu">
//           <ul className="nav">
//             {SidebarData?.map((mainTittle, mainIndex) => (
//               <li
//                 className="submenu"
//                 key={mainIndex}
//                 onMouseLeave={() => setOpendSubMenu([null, null])}
//               >
//                 <NavLink
//                   to={mainTittle.link}
//                   className={`${opendSubMenu[0] === mainTittle?.label ||
//                       isActiveMainMenu(mainTittle)
//                       ? "active"
//                       : ""
//                     }`}
//                   onClick={(e) => {
//                     if (mainTittle?.submenuItems?.length > 0) {
//                       e.preventDefault();
//                       showMenu(mainTittle?.label);
//                     } else {
//                       setOpendSubMenu([null, null]);
//                     }
//                   }}
//                 >
//                   <i className={`ti ti-${mainTittle?.icon} me-2`}></i>
//                   <span>{mainTittle?.label}</span>
//                   {mainTittle?.submenuItems?.length > 0 ? (
//                     <span className="menu-arrow"></span>
//                   ) : (
//                     ""
//                   )}
//                 </NavLink>
//                 {mainTittle?.submenuItems?.length > 0 && (
//                   <ul
//                     className={`submenus-two ${opendSubMenu[0] === mainTittle?.label
//                         ? "d-block"
//                         : "d-none"
//                       } border border-1 shadow rounded-bottom`}
//                   >
//                     {mainTittle?.submenuItems?.map((mainMenus, menuIndex) => (
//                       <React.Fragment key={menuIndex}>
//                         {mainMenus.submenuItems?.length === 0 && (
//                           <li>
//                             <NavLink
//                               to={mainMenus.link}
//                               className={({ isActive }) =>
//                                 isActive ? "active" : ""
//                               }
//                             >
//                               <span>{mainMenus.label}</span>
//                             </NavLink>
//                           </li>
//                         )}

//                         {mainMenus.submenuItems?.length > 0 && (
//                           <li className="submenu">
//                             <a
//                               className={`${isActiveSubMenu(mainMenus) ? "active" : ""
//                                 }`}
//                               onClick={() => {
//                                 showSubMenu(mainMenus.label);
//                               }}
//                             >
//                               <span>{mainMenus.label}</span>
//                               <span className="menu-arrow"></span>
//                             </a>

//                             <ul
//                               className={`submenus-two ${opendSubMenu[1] === mainMenus.label
//                                   ? "d-block"
//                                   : "d-none"
//                                 } border border-1 shadow rounded-bottom`}
//                             >
//                               {mainMenus.submenuItems?.map(
//                                 (submenuItems, subIndex) => (
//                                   <li key={subIndex}>
//                                     <NavLink
//                                       to={submenuItems.link}
//                                       className={({ isActive }) =>
//                                         isActive ? "active" : ""
//                                       }
//                                       onClick={() =>
//                                         setOpendSubMenu([null, null])
//                                       }
//                                     >
//                                       {submenuItems.label}
//                                     </NavLink>
//                                   </li>
//                                 )
//                               )}
//                             </ul>
//                           </li>
//                         )}
//                       </React.Fragment>
//                     ))}
//                   </ul>
//                 )}
//               </li>
//             ))}
//           </ul>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default HorizontalSidebar;

import React, { useEffect, useRef, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { SidebarData1 } from "../../core/json/sidebar_dataone";

const HorizontalSidebar = () => {
  const [opendSubMenu, setOpendSubMenu] = useState([null, null]);
  const sidebarRef = useRef(null);
  const location = useLocation();
  const currentPath = location.pathname.split("/")[1];

  const showMenu = (title) => {
    setOpendSubMenu((prevState) =>
      prevState[0] === title ? [null, null] : [title, null]
    );
  };

  const showSubMenu = (title) => {
    setOpendSubMenu((prevState) =>
      prevState[1] === title ? [prevState[0], null] : [prevState[0], title]
    );
  };

  const handleClickOutside = (event) => {
    if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
      setOpendSubMenu([null, null]);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const filteredMenu = Object.keys(SidebarData1).find((key) =>
    location.pathname.startsWith(`/${key}`)
  )
    ? SidebarData1[currentPath]
    : [];

  // console.log("Filtered Menu:", filteredMenu);

  const isActiveMainMenu = (mainMenus) => {
    // console.log(mainMenus)
    const currentPath = location.pathname || "";

    return (
      (mainMenus.route &&
        currentPath.split("/")[1] === mainMenus.route.split("/")[1]) ||
      mainMenus.subRoutes?.some(
        (subMenu) =>
          subMenu.route &&
          currentPath.split("/")[1] === subMenu.route.split("/")[1]
      )
    );
  };

  const isActiveSubMenu = (mainMenus) => {
    const currentPath = location.pathname || "";
    console.log(currentPath);
    return (
      (mainMenus.route &&
        currentPath.split("/")[1] === mainMenus.route.split("/")[1]) ||
      mainMenus.subRoutes?.some(
        (subMenu) =>
          subMenu.route &&
          currentPath.split("/")[1] === subMenu.route.split("/")[1]
      )
    );
  };
  return (
    <div
      className="sidebar sidebar-horizontal"
      id="horizontal-menu"
      ref={sidebarRef}
    >
      <div className="sidebar-menu" id="sidebar-menu-3">
        <div className="main-menu">
          <ul className="nav">
            {filteredMenu?.map((mainTittle, mainIndex) => (
              <li className="submenu" key={mainIndex}>
                <NavLink
                  to={mainTittle.route}
                  className={`${
                    opendSubMenu[0] === mainTittle.tittle ||
                    isActiveMainMenu(mainTittle)
                      ? "active"
                      : ""
                  }`}
                  onClick={() => showMenu(mainTittle.tittle)}
                >
                  {mainTittle.tittle === "Components" ? (
                    <i className="feather icon-layers"></i>
                  ) : (
                    <i className={`ti ti-${mainTittle.icon} me-2`}></i>
                  )}

                  <span>{mainTittle.tittle}</span>
                  {mainTittle.hasSubRoute ? (
                    <span className="menu-arrow"></span>
                  ) : (
                    ""
                  )}
                </NavLink>
                <ul
                  className={`submenus-two ${
                    opendSubMenu[0] === mainTittle?.tittle
                      ? "d-block"
                      : "d-none"
                  }`}
                >
                  {mainTittle?.subRoutes?.map((mainMenus, menuIndex) => (
                    <React.Fragment key={menuIndex}>
                      {!mainMenus.hasSubRoute && (
                        <li>
                          <NavLink
                            to={mainMenus.route}
                            className={({ isActive }) =>
                              isActive ? "active" : ""
                            }
                          >
                            {/* <img
                              src={mainMenus.icon}
                              alt="icon"
                              hidden={
                                mainTittle.tittle === 'Inventory' ||
                                mainTittle.tittle === 'Profile' ||
                                mainTittle.tittle === 'Reports' ||
                                mainTittle.tittle === 'Settings'
                              }
                            /> */}

                            <span>{mainMenus.tittle}</span>
                          </NavLink>
                        </li>
                      )}
                      {mainMenus.hasSubRoute && (
                        <li className="submenu">
                          <a
                            className={`${
                              isActiveSubMenu(mainMenus) ? "active" : ""
                            }`}
                            onClick={() => showSubMenu(mainMenus.tittle)}
                          >
                            <span>{mainMenus.tittle}</span>
                            <span className="menu-arrow"></span>
                          </a>
                          <ul
                            className={`submenus-two ${
                              opendSubMenu[1] === mainMenus.tittle
                                ? "d-block"
                                : "d-none"
                            }`}
                          >
                            {mainMenus.subRoutes?.map(
                              (subDropMenus, subIndex) => (
                                <li key={subIndex} className="submenu">
                                  {subDropMenus.hasSubRoute ? (
                                    <>
                                      <a
                                        className={`${
                                          isActiveSubMenu(subDropMenus)
                                            ? "active"
                                            : ""
                                        }`}
                                        onClick={() =>
                                          showSubMenu(subDropMenus.tittle)
                                        }
                                      >
                                        <span>{subDropMenus.tittle}</span>
                                        <span className="menu-arrow"></span>
                                      </a>
                                      <ul
                                        className={`submenus-two ${
                                          opendSubMenu[1] ===
                                          subDropMenus.tittle
                                            ? "d-block"
                                            : "d-none"
                                        }`}
                                      >
                                        {subDropMenus.subRoutes?.map(
                                          (childMenu, childIndex) => (
                                            <li key={childIndex}>
                                              <NavLink
                                                to={childMenu.route}
                                                className={({ isActive }) =>
                                                  isActive ? "active" : ""
                                                }
                                              >
                                                {childMenu.tittle}
                                              </NavLink>
                                            </li>
                                          )
                                        )}
                                      </ul>
                                    </>
                                  ) : (
                                    <NavLink
                                      to={subDropMenus.route}
                                      className={({ isActive }) =>
                                        isActive ? "active" : ""
                                      }
                                    >
                                      {subDropMenus.tittle}
                                    </NavLink>
                                  )}
                                </li>
                              )
                            )}
                          </ul>
                        </li>
                      )}
                    </React.Fragment>
                  ))}
                </ul>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default HorizontalSidebar;
